<template>
  <BCard>
    <b-row class="mx-0">
      <b-button
        variant="primary"
        size="md"
        class="mr-1 rounded-lg p-0"
        @click="$router.go(-1)"
      >
        <feather-icon
          size="2x"
          icon="ChevronLeftIcon"
        />
      </b-button>
      <h3 class="font-semibold text-black text-2xl m-0">
        Tinjauan Kendala Order {{ isPageSent ? 'Dikirim' : 'Retur' }}
      </h3>
    </b-row>
    <b-row class="mx-0 my-2">
      <div class="ml-3 text-black text-[16px]">
        Analisa jenis kendala dari orderan dikirim kamu. Dibawah ini adalah data dari semua Ekspedisi.
      </div>
    </b-row>
    <b-row class="mx-0 text-black">
      <b-row
        class="mx-0 w-full"
      >
        <b-row
          class="bg-[#E2E2E2] mx-0 w-full p-1"
          style="border-top-left-radius: 16px; border-top-right-radius: 16px;"
        >
          <b-col
            md="2"
            class="font-medium align-self-center"
          >
            Lihat data dari
          </b-col>
          <b-col md="3">
            <BButton
              id="filter-problem"
              variant="light"
              class="rounded-lg w-full p-0"
              style="border: solid 1px #d8d6de !important; padding: 8px !important;"
            >
              <div
                class="flex flex-row-reverse items-center justify-between h-full w-full"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/arrow-down-light.svg"
                  alt="arrow-down"
                >
                <span class="leading-[1.2]">{{ filterProblem }}</span>
              </div>
            </BButton>
            <BPopover
              ref="filter-problem"
              target="filter-problem"
              triggers="focus"
              placement="bottom"
              custom-class="wrapper-shipment"
            >
              <b-list-group>
                <b-list-group-item
                  v-for="(item, index) in problemList"
                  :key="index"
                  class="cursor-pointer"
                  :active="item === filterProblem"
                  @click="filterByProblem(item)"
                >
                  {{ item }}
                </b-list-group-item>
              </b-list-group>
            </BPopover>
          </b-col>
          <b-col
            md="2"
            class="align-content-center"
          >
            <flat-pickr
              v-model="filterMonth"
              class="custom-select bg-white"
              :config="flatpickrMonthly"
            />
          </b-col>
        </b-row>
        <b-row class="mx-0 border-2 w-full p-1">
          <b-row class="w-full mx-1 justify-between">
            <b-col
              md="8"
              class="border-2 rounded-xl mr-1"
              :class="(chart === null || count === 0) ? 'place-content-center' : ''"
            >
              <div v-if="(chart !== null && count !== 0) || isLoading">
                <BOverlay
                  id="chart"
                  :show="isLoading"
                >
                  <div
                    v-if="filterProblem === 'Jenis Kendala'"
                    class="w-full mt-1"
                    style="text-align-last: right;"
                  >
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      @click="redirectPage()"
                    >
                      <div class="d-flex gap-2 text-black">
                        <div>Lihat Selengkapnya </div>
                        <div class="k-arrow-right-3 align-self-center" />
                      </div>
                    </b-button>
                  </div>
                  <VueApexcharts
                    :width="`80%`"
                    :options="chartOptions"
                    :series="series"
                  />
                </BOverlay>
              </div>
              <div
                v-else
                class="w-full text-center"
              >
                Tidak Ada Data Untuk Ditampilkan
              </div>
            </b-col>
            <b-col
              class="border-2 rounded-xl"
            >
              <div class="d-flex gap-4 my-2">
                <div class="bg-[#FFEDED] py-[2px] px-[5px] rounded-pill">
                  <span class="k-danger text-[#D6292F] text-2xl" />
                </div>
                <span class="align-self-center text-black">Total {{ isPageSent ? 'Dikirim Terkena Kendala' : 'Retur' }}</span>
              </div>
              <div class="text-[36px] font-semibold ml-1 mb-2">
                <b-spinner
                  v-if="isLoading"
                  small
                  variant="primary"
                />
                <span v-else>
                  {{ count }}
                </span>
              </div>
              <div v-if="chart !== null || isLoading">
                <div v-if="filterProblem === 'Jenis Kendala'">
                  <div
                    v-for="(item, idx) in chart"
                    :key="idx"
                    :class="getClass(idx).class"
                    class="p-1 mb-1 rounded-xl"
                    :style="getClass(idx).style"
                  >
                    <div class="d-flex place-items-center">
                      <div
                        class="mr-1 p-[5px] w-[5px] h-[5px] rounded rounded-pill"
                        :class="getClass(idx).bullet"
                      />
                      <span class="align-self-center">{{ item.name }}</span>
                    </div>
                    <b-spinner
                      v-if="isLoading"
                      small
                      variant="primary"
                    />
                    <div
                      v-else
                      class="text-3xl font-semibold ml-1 my-2"
                    >
                      {{ item.count }} ({{ item.percentage.toFixed(1) }})%
                    </div>
                  </div>
                </div>
                <b-row
                  v-else
                  class="d-flex gap-1 justify-center pb-1"
                >
                  <b-col
                    v-for="(item, idx) in chart"
                    :key="idx"
                    :cols="chart.length % 2 === 1 && idx === chart.length - 1 ? 10 : 5"
                    :class="getClass(item.name).class"
                    class="p-1 rounded-xl"
                    :style="getClass(item.name).style"
                  >
                    <div class="d-flex place-items-center">
                      <div
                        class="mr-1 p-[5px] w-[5px] h-[5px] rounded rounded-pill"
                        :class="getClass(item.name).bullet"
                      />
                      <span class="align-self-center">{{ item.name === 'SAP' ? 'SAPX' : item.name }}</span>
                    </div>
                    <b-spinner
                      v-if="isLoading"
                      small
                      variant="primary"
                    />
                    <div
                      v-else
                      class="text-3xl font-semibold ml-1 my-2"
                    >
                      {{ item.count }} ({{ item.percentage.toFixed(1) }})%
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-row>
      </b-row>
    </b-row>
  </BCard>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import VueApexcharts from 'vue-apexcharts'
import { today, formatYmd } from '@/store/helpers'
import { BOverlay } from 'bootstrap-vue'
import {
  configFlatPickr,
  configPieChart,
  PROBLEM_INDEX_STYLES,
  EXPEDITION_STYLES,
  EXPEDITION_COLORS,
  DEFAULT_EXPEDITION_STYLE,
  PROBLEM_INDEX_COLORS,
} from './component/config'

export default {
  components: {
    flatPickr,
    VueApexcharts,
    BOverlay,
  },
  data() {
    return {
      isPageSent: true,
      isLoading: false,
      count: null,
      filterProblem: 'Jenis Kendala',
      problemList: ['Jenis Kendala', 'Ekspedisi'],
      filterMonth: this.$route.params?.date || formatYmd(today),
      flatpickrMonthly: configFlatPickr,
      chart: [],
      series: [],
      chartOptions: configPieChart,
    }
  },
  watch: {
    filterMonth(newVal) {
      if (newVal !== null) this.fetchData()
    },
    filterProblem(newVal) {
      if (newVal !== null) this.fetchData()
    },
  },
  mounted() {
    this.isPageSent = this.$route.name === 'order-dikirim'
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      this.series = []

      const isJenisKendala = this.filterProblem === 'Jenis Kendala'
      const type = isJenisKendala ? '' : '-expedition'
      const page = this.isPageSent ? 'sent' : 'return'
      const url = `/komship/api/v1/delivery-insight/problem-review${type}/${page}`

      try {
        const res = await this.$http_new.get(url, { params: { date: this.filterMonth } })
        const { data } = res.data
        this.count = data.total_order
        this.chart = data.chart

        if (this.chart) {
          this.series = this.chart.map(item => item.count)

          const colors = isJenisKendala
            ? PROBLEM_INDEX_COLORS
            : this.chart.map(item => EXPEDITION_COLORS[item.name.toUpperCase()])

          this.chartOptions = {
            ...this.chartOptions,
            labels: this.chart.map(item => item.name),
            colors,
          }
        }
      } catch {
        this.$toast_error({ message: 'Gagal Mendapatkan Data Problem' })
      } finally {
        this.isLoading = false
      }
    },

    filterByProblem(value) {
      this.filterProblem = value
      this.$refs['filter-problem'].$emit('close')
    },

    /**
     * Mengembalikan object { class, style, bullet } berdasarkan:
     * - number (0–3): mode Jenis Kendala → index ke PROBLEM_INDEX_STYLES
     * - string (nama ekspedisi): mode Ekspedisi → lookup di EXPEDITION_STYLES
     */
    getClass(value) {
      if (typeof value === 'number') {
        return PROBLEM_INDEX_STYLES[value] ?? PROBLEM_INDEX_STYLES[PROBLEM_INDEX_STYLES.length - 1]
      }
      return EXPEDITION_STYLES[value?.toUpperCase()] ?? DEFAULT_EXPEDITION_STYLE
    },

    redirectPage() {
      const targetRoute = this.isPageSent ? 'order-detail-dikirim' : 'order-detail-retur'
      this.$router.push({ name: targetRoute, params: { date: this.filterMonth } })
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-flatpicker.scss';

.wrapper-shipment > .popover-body {
  padding: 0 !important;
  min-width: 200px;
}
</style>
